import React from "react";
import "cropperjs/dist/cropper.min.css";
import { Box, Button } from "@mui/material";
import styles from "./style.module.css";
import { useTheme } from "../../../../../../context/themeContext";
import { creatorDefaultImages, node_server } from "../../../../../../constants";
import { useDispatch, useSelector } from "react-redux";
import { updateSkillImageData } from "../../../../../../store/slices/profile/skillImageSlice";
import { setIsPageLoading } from "../../../../../../store/slices/loadingSlice";
import axios from "axios";
import {
  setActiveUserSkill,
  setUserSkills,
} from "../../../../../../store/slices/userSlice";

const DeleteSkillImage = () => {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const { activeUserSkill } = useSelector((state) => state.user);
  const { userSkills } = useSelector((state) => state.user);

  const handleDelete = async () => {
    try {
      dispatch(setIsPageLoading(true));

      dispatch(
        updateSkillImageData({
          isSkillImageDeleteOpen: false,
          selectedSkillImage: null,
        })
      );

      const targetCreatorType = activeUserSkill.category;
      const targetImage = creatorDefaultImages[targetCreatorType];
      const original = targetImage;
      const cropp = targetImage;

      const { data: updatedSkill, error: updatedSkillError } = await axios.post(
        `${node_server}/api/skills/update`,
        {
          skillCoverImage: cropp,
          originalCoverImage: original,
        },
        {
          params: { id: activeUserSkill.id },
          withCredentials: true,
        }
      );

      if (updatedSkillError) console.error(updatedSkillError);
      if (updatedSkill) {
        dispatch(setUserSkills(updatedSkill));
      }

      dispatch(setIsPageLoading(false));
    } catch (error) {
      console.error(error);
      dispatch(setIsPageLoading(false));
    }
  };

  const handleCancel = () => {
    dispatch(
      updateSkillImageData({
        isSkillImageDeleteOpen: false,
        selectedSkillImage: null,
      })
    );
  };

  return (
    <Box className={styles.parent}>
      <Box
        className={styles.container}
        sx={{
          backgroundImage: `url(${activeUserSkill.originalCoverImage})`,
          width: {
            xs: "100%",
            md: "400px",
          },
        }}
      >
        <Box className={styles.frame}>
          <Box className={styles.content}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleDelete}
              sx={{
                textTransform: "capitalize",
                bgcolor: "#fff",
                color: theme.palette.danger.red500,
                fontWeight: 500,
              }}
            >
              Delete
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={handleCancel}
              sx={{
                textTransform: "capitalize",
                bgcolor: "#fff",
                color: theme.palette.secondary.dark,
                fontWeight: 500,
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DeleteSkillImage;
